<template>
  <div id="app-container">

    <div id="map-container" ref="map"></div>

    <!-- Detail Page Overlay -->
    <transition name="slide-up">
      <div v-if="showDetailPage" class="detail-page-overlay" @click.self="closeDetailPage">
        <div class="detail-page-content">
          <div class="detail-header">
            <h3>{{ detailTitle }}</h3>
            <button class="close-btn" @click="closeDetailPage">×</button>
          </div>

          <div class="detail-body">
            <!-- Bilibili Video Embed -->
            <div class="video-container" v-if="videoSrc">
              <iframe
                  :src="videoSrc"
                  scrolling="no"
                  border="0"
                  frameborder="no"
                  framespacing="0"
                  allowfullscreen="true">
              </iframe>
            </div>

            <!-- Optional Images -->
            <div class="image-gallery" v-if="imageList && imageList.length > 0" id="images">
              <img v-for="(img, idx) in imageList" :key="idx" :src="img" class="detail-image"
                   alt="Detail Image"/>
            </div>

            <div class="detail-text" v-if="detailData.description">
              <p>{{ detailData.description }}</p>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <div class="bottom-nav">
      <!--      <div v-for="(btn, index) in buttons" :key="index" class="nav-item-wrapper">-->
      <!--        &lt;!&ndash; Menu for the second button (index 1) &ndash;&gt;-->
      <!--              <div v-if="index === 1 && showMenu" class="popup-menu">-->
      <!--                <div v-for="(item, mIndex) in menuItems" :key="mIndex" class="menu-item" @click="handleMenuClick(item)">-->
      <!--                  <span class="menu-icon">{{ item.icon }}</span>-->
      <!--                  <span class="menu-label">{{ item.label }}</span>-->
      <!--                </div>-->
      <!--              </div>-->

      <!--        <button class="nav-btn" @click="handleNavClick(index)">-->
      <!--          <span class="icon">{{ getButtonIcon(btn) }}</span>-->
      <!--          <span v-if="btn.label" class="label">{{ btn.label }}</span>-->
      <!--        </button>-->
      <!--      </div>-->
      <div class="nav-item-wrapper">
        <button class="nav-btn" @click="showGameOption">
          <img :src="config.game[currentPage].logoSrc" class="game-icon" alt="val"/>
        </button>
      </div>
      <template v-if="currentPage==='val'">
        <div class="nav-item-wrapper">
          <button class="nav-btn" @click="showMapOptions">
            <!--          <span class="icon">-->
            <!--            <img :src="config.game.val.maps[userSelect.val.map].imgSrc" class="map-icon" alt="">-->
            <!--          </span>-->
            <span>
            {{ config.game.val.maps[userSelect.val.map].chTitle }}
          </span>
          </button>
        </div>

        <div class="nav-item-wrapper">
          <button class="nav-btn" @click="showAgentOptions">
          <span class="icon">
            <img :src="config.game.val.agents[userSelect.val.agent].imgSrc" class="agent-icon">
          </span>
          </button>
        </div>


        <div class="nav-item-wrapper">

          <div class="popup-menu" v-if="abilityOptionsVisible">
            <template v-for="(value, name, index) in config.game.val.agents[userSelect.val.agent].ability">
              <div class="menu-item" :key="index">
                <template
                    v-if="mapToAgent[userSelect.val.map] && mapToAgent[userSelect.val.map][userSelect.val.agent] && mapToAgent[userSelect.val.map][userSelect.val.agent][name]">
                  <el-badge :value="mapToAgent[userSelect.val.map][userSelect.val.agent][name]" class="item"
                            :key="index">
                    <div class="ability-item" @click="clickAbilityOption(name)">
                      <img :src="value.imgSrc" alt="" v-bind:class="{'img-opacity2': userSelect.val.ability!=name}"
                           class="ability-icon">
                    </div>
                  </el-badge>
                </template>
                <template v-else>
                  <div class="ability-item" @click="clickAbilityOption(name)" :key="index">
                    <img :src="value.imgSrc" alt="" v-bind:class="{'img-opacity2': userSelect.val.ability!=name}"
                         class="ability-icon">
                  </div>
                </template>
              </div>
            </template>
          </div>

          <button class="nav-btn" @click="showAbilityOptions">
          <span class="icon">
            <div class="ability-item">
              <img
                  :src="config.game.val.agents[userSelect.val.agent].ability[userSelect.val.ability].imgSrc"
                  class="ability-icon" alt="">
            </div>

          </span>
            <span>
          </span>
          </button>
        </div>


      </template>

      <!--      cs2-->
      <template v-else-if="currentPage==='cs2'">

        <div class="nav-item-wrapper">
          <button class="nav-btn" @click="showCS2MapOptions">
            <span>
            {{ config.game.cs2.maps[userSelect.cs2.map].chTitle }}
          </span>
          </button>
        </div>


        <div class="nav-item-wrapper">
          <div class="popup-menu" v-if="cs2AbilityOptionsVisible">
            <template v-for="(value, name, index) in config.game.cs2.ability">
              <div class="menu-item" :key="index">
                <template v-if="cs2MapToAbility[userSelect.cs2.map] && cs2MapToAbility[userSelect.cs2.map][name]">
                  <el-badge :value="cs2MapToAbility[userSelect.cs2.map][name]" class="item"
                            :key="index">
                    <div class="ability-item" @click="clickCS2AbilityOption(name)">
                      <img :src="value.imgSrc" alt="" v-bind:class="{'img-opacity2': userSelect.cs2.ability!=name}"
                           class="ability-icon">
                    </div>
                  </el-badge>
                </template>
                <template v-else>
                  <div class="ability-item" @click="clickCS2AbilityOption(name)" :key="index">
                    <img :src="value.imgSrc" alt="" v-bind:class="{'img-opacity2': userSelect.cs2.ability!=name}"
                         class="ability-icon">
                  </div>
                </template>
              </div>
            </template>
          </div>
          <button class="nav-btn" @click="showCS2AbilityOptions">
          <span class="icon">
            <div class="ability-item">
              <img
                  :src="config.game.cs2.ability[userSelect.cs2.ability].imgSrc"
                  class="ability-icon" alt="">
            </div>
          </span>
            <span>
          </span>
          </button>
        </div>


        <div class="nav-item-wrapper">
          <button class="nav-btn" @click="clickCS2SideOption">
            <img :src="config.game.cs2.side[userSelect.cs2.side].imgSrc" class="side-icon" alt="val"/>
          </button>
        </div>
      </template>
      <template v-else>
        <div class="nav-item-wrapper">
          <button class="nav-btn" @click="showDFMapOptions">
            <!--          <span class="icon">-->
            <!--            <img :src="config.game.val.maps[userSelect.val.map].imgSrc" class="map-icon" alt="">-->
            <!--          </span>-->
            <span>
            {{ config.game.df.maps[userSelect.df.map].chTitle }}
          </span>
          </button>
        </div>

        <div class="nav-item-wrapper">
          <button class="nav-btn" @click="showDFAgentOptions">
          <span class="icon">
            <img :src="config.game.df.agents[userSelect.df.agent].imgSrc" class="agent-icon">
          </span>
            <span>
            {{ config.game.df.agents[userSelect.df.agent].chTitle }}
          </span>
          </button>
        </div>

      </template>


    </div>
    <!--第一次进入网站进行游戏选择-->
    <el-dialog
        title="选择游戏"
        :visible.sync="gameSelectVisible"
        :show-close="false"
        :width="'100%'">
      <div class="out-parent">
        <div class="share-item" @click="clickGameOption('val')">
          <!--          <span class="demonstration">无畏契约</span>-->
          <el-image :src="config.game.val.logoSrc"
                    style="width: 100%"
          >
          </el-image>
        </div>
        <div class="share-item" @click="clickGameOption('cs2')">
          <!--          <span class="demonstration">CS2</span>-->
          <el-image :src="config.game.cs2.logoSrc"
                    style="width: 100%"
          ></el-image>
        </div>
        <div class="share-item" @click="clickGameOption('df')">
          <!--          <span class="demonstration">CS2</span>-->
          <el-image :src="config.game.df.logoSrc"
                    style="width: 100%"
          ></el-image>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
      </span>

    </el-dialog>
    <!--无畏契约地图选项-->
    <el-dialog
        title="选择地图"
        :visible.sync="mapOptionsVisible"
        :width="'100%'"
        top="50px"
    >
      <div class="map-options">
        <template v-for="(value, name, index) in config.game.val.maps">
          <template v-if="agentToMap[userSelect.val.agent] && agentToMap[userSelect.val.agent][name]">
            <el-badge :value="agentToMap[userSelect.val.agent][name]['count']" :key="index" class="agent-badge-item">
              <div class="map-item" @click="clickMapOption(name)">
                <img :src="value.imgSrc" alt="">
                <div class="map-title">
                  <div>{{ value.title }}</div>
                  <div>{{ value.chTitle }}</div>
                </div>
              </div>
            </el-badge>
          </template>
          <template v-else>
            <el-badge :key="index" class="agent-badge-item">
              <div class="map-item" :key="index" @click="clickMapOption(name)">
                <img :src="value.imgSrc" alt="">
                <div class="map-title">
                  <div>{{ value.title }}</div>
                  <div>{{ value.chTitle }}</div>
                </div>
              </div>
            </el-badge>
          </template>
        </template>
      </div>

    </el-dialog>
    <!--无畏契约英雄选项-->
    <el-dialog
        title="选择英雄"
        :visible.sync="agentOptionsVisible"
        :width="'100%'"
        top="50px"
    >
      <div class="agent-options">
        <template v-for="(value, name, index) in config.game.val.agents">
          <template v-if="mapToAgent[userSelect.val.map] && mapToAgent[userSelect.val.map][name]">
            <el-badge :value="mapToAgent[userSelect.val.map][name]['count']" class="agent-badge-item" :key="index">
              <div class="agent-item" :style="value.background" @click="clickAgentOption(name)">
                <img :src="value.imgSrc" alt="">
                <div class="agent-title">{{ value.chTitle }}</div>
              </div>
            </el-badge>
          </template>
          <template v-else>
            <el-badge class="agent-badge-item" :key="index">
              <div class="agent-item" :style="value.background" @click="clickAgentOption(name)">
                <img :src="value.imgSrc" alt="">
                <div class="agent-title">{{ value.chTitle }}</div>
              </div>
            </el-badge>
          </template>

        </template>
      </div>

    </el-dialog>
    <!--CS2地图选项-->
    <el-dialog
        title="选择地图"
        :visible.sync="mapCS2OptionsVisible"
        :width="'100%'">
      <div class="map-options">
        <template v-for="(value, name, index) in config.game.cs2.maps">
          <template v-if="cs2MapToAbility[name]">
            <el-badge :value="cs2MapToAbility[name]['count']" :key="index" class="agent-badge-item">
              <div class="map-item" :key="index" @click="clickCS2MapOption(name)">
                <img :src="value.imgSrc" alt="">
                <div class="map-title">
                  <div>{{ value.title }}</div>
                  <div>{{ value.chTitle }}</div>
                </div>
              </div>
            </el-badge>
          </template>
          <template v-else>
            <div class="map-item" :key="index" @click="clickCS2MapOption(name)">
              <img :src="value.imgSrc" alt="">
              <div class="map-title">
                <div>{{ value.title }}</div>
                <div>{{ value.chTitle }}</div>
              </div>
            </div>
          </template>
        </template>
      </div>
    </el-dialog>
    <!--三角洲地图选项-->
    <el-dialog
        title="选择地图"
        :visible.sync="mapDFOptionsVisible"
        :width="'100%'"
        top="50px"
    >
      <div class="map-options">
        <template v-for="(value, name, index) in config.game.df.maps">
          <el-badge :key="index" class="agent-badge-item">
            <div class="map-item" :key="index" @click="clickDFMapOption(name)">
              <img :src="value.imgSrc" alt="">
              <div class="map-title">
                <div>{{ value.chTitle }}</div>
              </div>
            </div>
          </el-badge>
        </template>
      </div>

    </el-dialog>
    <!--三角洲英雄选项-->
    <el-dialog
        title="选择英雄"
        :visible.sync="agentDFOptionsVisible"
        :width="'100%'"
        top="50px"
    >
      <div class="agent-options">
        <template v-for="(value, name, index) in config.game.df.agents">
          <el-badge class="agent-badge-item" :key="index">
            <div class="agent-item" @click="clickDFAgentOption(name)">
              <img :src="value.imgSrc" alt="">
              <div class="agent-title">{{ value.chTitle }}</div>
            </div>
          </el-badge>
        </template>
      </div>

    </el-dialog>
    <el-dialog
        title="视频列表"
        :visible.sync="vd_videoDialogVisible"
        width="80%"
        class="vd-video-dialog"
        @open="handleDialogOpen"
    >
      <div class="vd-video-list-container">
        <div
            class="vd-video-item"
            v-for="(item, index) in vd_videoCardList"
            :key="index"
            @click="getLineupDetail(item.blog_id)"
        >
          <div class="vd-video-wrapper">
            <video
                ref="vdVideoRefs"
                class="vd-video-content"
                :src="imgNameToUrl(item.video)"
                autoplay
                loop
                muted
                playsinline
                webkit-playsinline="true"
                x5-playsinline="true"
                disablepictureinpicture
                controlslist="nodownload nofullscreen noremoteplayback"
                preload="auto"
                @error="handleVideoError(item)"
                @canplay="handleVideoCanPlay"
            >
              您的浏览器不支持HTML5视频播放
            </video>
          </div>
          <div class="vd-video-text">{{ item.title }}</div>
        </div>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import L from 'leaflet';
import {config} from "@/common/gameConfig";
import store from "@/store";
import axios from 'axios';
import {distance, imgNameToUrl} from "@/common/comm";
import {biliLinkToIframe} from "@/common/bili";
import Viewer from 'viewerjs'

let map
let startPoint //站点
let endPointGroup //落点
let tempRangePolygon //暂时的范围
let tempPolylineWithEndPoint //暂时的折线
let rangePolygonList
let endCircleLayerGroup = null // 初始化显示所有点位
let endCircleLayerGroupArr = []
let mouseOverLayerGroup  // 鼠标移入技能图片时显示的东西
let multipleLayerGroup = null // 点击聚合点位时显示的东西，多个直线连接至多个人物站位
let multipleLayerGroupArr = []


export default {
  name: 'App',
  data() {
    return {
      imgNameToUrl,
      config,
      gameSelectVisible: false, // 显示游戏选择框，先默认为true
      userSelect: {
        val: {
          map: 'haven',
          agent: 'sova',
          ability: 4,
          side: 0,
        },
        cs2: {
          map: 'dust2',
          agent: '',
          side: 0,
          ability: 1,
        },
        df: {
          map: 'htjd',
          agent: 'luna',
          side: 0,
          ability: 0,
        }
      },
      //地图选择的对话框是否显示
      mapOptionsVisible: false,
      agentOptionsVisible: false,
      mapCS2OptionsVisible: false,
      mapDFOptionsVisible: false,
      agentDFOptionsVisible: false,
      abilityOptionsVisible: false,
      cs2AbilityOptionsVisible: false,
      vd_videoDialogVisible: false,
      // 展示各个地图，各个英雄，各个技能的数量
      mapToAgent: {},
      agentToMap: {},
      cs2MapToAbility: {},
      vd_videoCardList: [],
      vd_videoCardTitle: '',
      showMenu: false,
      showDetailPage: false,
      detailData: {
        title: '',
        videoBvid: '',
        images: [],
        description: ''
      },
      menuItems: [
        {label: '扫一扫', icon: '📸'},
        {label: '添加朋友', icon: '➕'},
        {label: '收付款', icon: '💰'}
      ],
      buttons: [
        {label: '首页', icon: '🏠'},
        {label: '发现', icon: '🔍'}, // Button 2: Popup menu
        {label: '消息', icon: '💬'},
        {
          // Button 4: Image only, cycling images
          label: null,
          icon: null,
          images: ['👤', '⚙️', '🔒'],
          currentImageIndex: 0
        },
      ],

      // 展示lineup内容
      detail: {},
      detailDialogVisible: false,
      detailTitle: '',
      videoSrc: '', //B站视频嵌入地址（替换为实际地址）
      linkWithSecond: '',
      imageList: [], // 图片列表
      imageViewer: null, // Viewer实例
    };
  },
  computed: {
    currentPage() {
      return this.$store.state.currentPage
    }
  },
  mounted() {
    if (localStorage.getItem('currentPage')) { // 已经选择过游戏了
      this.gameSelectVisible = false
      store.commit('setCurrentPage', localStorage.getItem('currentPage'))
    } else { // 从未访问过网站
      this.gameSelectVisible = true
    }
    //读取之前用户的选择
    const savedUserSelectString = localStorage.getItem('userSelect')
    if (savedUserSelectString) {
      const savedUserSelect = JSON.parse(savedUserSelectString)
      for (let i in savedUserSelect) {
        for (let j in savedUserSelect[i]) {
          this.userSelect[i][j] = savedUserSelect[i][j]
        }
      }
      this.userSelect.val.side = 0
    }
    this.initMap();
    this.selectChange()
    this.getLineupCount()
    // Close menu when clicking outside
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeDestroy() {
    if (this.map) {
      this.map.remove();
    }
    if (this.imageViewer) {
      this.imageViewer.destroy()
      this.imageViewer = null
    }
    document.removeEventListener('click', this.handleClickOutside);
  },
  methods: {
    initMap() { // 初始化地图
      if (map) {
        map.remove()
      }
      const pngHeight = 2000
      const mapDivHeight = this.$refs.map.offsetHeight
      const mapDivWidth = this.$refs.map.offsetWidth
      let mapZoom
      if (mapDivHeight > mapDivWidth) {
        mapZoom = Math.log2(mapDivWidth / pngHeight)
      } else {
        mapZoom = Math.log2(mapDivHeight * 0.95 / pngHeight)
      }
      map = L.map(this.$refs.map, {
        crs: L.CRS.Simple,
        zoom: mapZoom,
        zoomSnap: 0.1,
        attributionControl: false,
      });
      // 窗格用于控制地图上图层顺序
      map.createPane('labels')
      map.getPane('labels').style.zIndex = 650
      let bounds = [[0, 0], [2000, 2000]]
      const selectMap = this.userSelect[this.currentPage].map
      L.imageOverlay(config.game[this.currentPage].maps[selectMap].radarImgSrc, bounds).addTo(map)
      map.fitBounds(bounds);
      map.setView([1000, 1000], mapZoom)
    },
    openDetailPage(data) {
      this.detailData = data;
      this.showDetailPage = true;
    },
    closeDetailPage() {
      this.showDetailPage = false;
      if (this.imageViewer) {
        this.imageViewer.destroy()
        this.imageViewer = null
      }
      this.videoSrc = ''
    },
    endCircleClick(e) {
      if (this.isSelectPointing) {
        return
      }
      if (multipleLayerGroup) {
        multipleLayerGroupArr.forEach(p => {
          p.off('tap click', this.endCircleClick);
        });
        map.removeLayer(multipleLayerGroup)
        multipleLayerGroupArr = []
        multipleLayerGroup = null
      }

      let lineupList = e.sourceTarget.options.lineupList
      console.log(lineupList.length)
      if (lineupList.length === 1) {
        let lineupObj = lineupList[0]
        // 延迟调用，确保 Leaflet 清理完成
        setTimeout(() => {
          if (lineupObj.blog_id_list !== '') {
            this.getBlogListDetail(lineupObj.blog_id_list, lineupObj.lineup_title)
          } else {
            this.getLineupDetail(lineupObj.blog_id)
          }
        }, 50)
      } else {
        this.$message('多个站位，点击站位查看对应教学');
        let endX = e.sourceTarget.options.togetherObj.endX
        let endY = e.sourceTarget.options.togetherObj.endY
        let circle = L.circle([endX, endY], {
          radius: config.game[this.currentPage].leaflet.showLineup.endCircleMouseOver.radius,
          color: config.game[this.currentPage].leaflet.showLineup.endCircleMouseOver.color,
          weight: config.game[this.currentPage].leaflet.showLineup.endCircleMouseOver.weight,
        })
        multipleLayerGroupArr.push(circle)
        for (let i = 0; i < lineupList.length; i++) {
          let lineupObj = lineupList[i]
          let startX = lineupObj.leaflet_params.startPoint[0]
          let startY = lineupObj.leaflet_params.startPoint[1]
          let endX = lineupObj.leaflet_params.endPoint[0]
          let endY = lineupObj.leaflet_params.endPoint[1]
          let startEndLine = L.polyline([[startX, startY], [endX, endY]], {
            color: config.game[this.currentPage].leaflet.showLineup.startEndLine.color,
            weight: config.game[this.currentPage].leaflet.showLineup.startEndLine.weight,
          });
          multipleLayerGroupArr.push(startEndLine)
          if (this.currentPage === 'val') {
            let imgSize = config.game.val.leaflet.showLineup.agentImgSize
            let agent = lineupObj.agent_name
            let pngBounds = [[startX - imgSize / 2, startY - imgSize / 2], [startX + imgSize / 2, startY + imgSize / 2]]
            let agentPng = L.imageOverlay(config.game.val.agents[agent].imgSrc, pngBounds, {
              zIndex: 401,
              interactive: true,
              lineupList: [lineupObj],
              togetherObj: e.sourceTarget.options.togetherObj,
            })
            agentPng.on('tap click', this.endCircleClick)
            multipleLayerGroupArr.push(agentPng)
            let agentCircle = L.circle([startX, startY], {
              radius: config.game[this.currentPage].leaflet.showLineup.agentCircle.radius,
              weight: config.game[this.currentPage].leaflet.showLineup.agentCircle.weight,
              fillOpacity: config.game[this.currentPage].leaflet.showLineup.agentCircle.fillOpacity,
              fillColor: config.game[this.currentPage].agents[agent].color,
              togetherObj: e.sourceTarget.options.togetherObj,
              lineupList: [lineupObj]
            })
            agentCircle.on('tap click', this.endCircleClick)
            multipleLayerGroupArr.push(agentCircle)
          } else {
            let agentCircle
            if (lineupObj.start_image === '') {
              agentCircle = L.circle([startX, startY], {
                radius: config.game[this.currentPage].leaflet.showLineup.agentCircle.radius,
                weight: config.game[this.currentPage].leaflet.showLineup.agentCircle.weight,
                fillOpacity: config.game[this.currentPage].leaflet.showLineup.agentCircle.fillOpacity,
                fillColor: config.game[this.currentPage].leaflet.showLineup.agentCircle.fillColor,
                color: config.game[this.currentPage].leaflet.showLineup.agentCircle.color,
                lineupList: [lineupObj],
                togetherObj: e.sourceTarget.options.togetherObj,
                pane: 'labels'
              })
            } else {
              let sideLength = 40
              var bounds = [[startX - sideLength / 2, startY - sideLength / 2], [startX + sideLength / 2, startY + sideLength / 2]]
              agentCircle = L.rectangle(bounds, {
                color: config.game[this.currentPage].leaflet.showLineup.agentRectangle.color,
                weight: config.game[this.currentPage].leaflet.showLineup.agentRectangle.weight,
                lineupList: [lineupObj],
                togetherObj: e.sourceTarget.options.togetherObj,
                pane: 'labels'
              })
            }
            agentCircle.on('tap click', this.endCircleClick)
            multipleLayerGroupArr.push(agentCircle)
          }
        }

        multipleLayerGroup = L.layerGroup(multipleLayerGroupArr)
        multipleLayerGroup.addTo(map)
      }
    },
    getButtonIcon(btn) {
      if (btn.images) {
        return btn.images[btn.currentImageIndex];
      }
      return btn.icon;
    },
    handleClickOutside(event) {
      // If menu is open and click is not inside the nav wrapper for the 2nd button
      if (this.showMenu) {
        const navWrapper = this.$el.querySelectorAll('.nav-item-wrapper')[1];
        if (navWrapper && !navWrapper.contains(event.target)) {
          this.showMenu = false;
        }
      }
    },
    showGameOption() {
      this.gameSelectVisible = true
    },
    clickGameOption(game) { // 用户第一次进入网站时，弹出对话框进行游戏的选择
      store.commit('setCurrentPage', game)
      localStorage.setItem('currentPage', game)
      this.gameSelectVisible = false
      this.initMap()
      this.selectChange()
    },
    selectChange() { // 用户切换选择（地图/英雄等等）
      const _this = this;
      this.cancelRequest();
      axios({
        method: 'get',
        url: '/api/blogs/get_lineup_list',
        params: {
          game: this.currentPage,
          userSelect: this.userSelect,
        },
        cancelToken: new axios.CancelToken(function executor(c) {
          _this.source = c
        })
      }).then(r => {
        if (r.data.code === 0) {
          this.initLineup(r.data.list)
        }
      })
    },
    initLineup(dataArr) {
      let _this = this
      if (endCircleLayerGroup) {
        endCircleLayerGroupArr.forEach(p => {
          p.off('tap click', this.endCircleClick);
        });
        map.removeLayer(endCircleLayerGroup)
        endCircleLayerGroupArr = []
        endCircleLayerGroup = null
      }
      if (multipleLayerGroup) {
        multipleLayerGroupArr.forEach(p => {
          p.off('tap click', this.endCircleClick);
        });
        map.removeLayer(multipleLayerGroup)
        multipleLayerGroupArr = []
        multipleLayerGroup = null
      }
      //把落点在一起的聚合起来，比如很多个位置都可以仍xbox烟，那么把这些xbox烟全部聚合起来
      let togetherList = []
      for (let i = 0; i < dataArr.length; i++) {
        if (!dataArr[i]) {
          continue
        }

        let lineupObj = dataArr[i]
        let endX = lineupObj.leaflet_params.endPoint[0]
        let endY = lineupObj.leaflet_params.endPoint[1]
        let togetherObj = {
          count: 1,
          endX: endX,
          endY: endY,
          list: [lineupObj],
          agent: lineupObj.agent_name,
          ability: lineupObj.ability,
        }
        for (let j = i + 1; j < dataArr.length; j++) {
          if (!dataArr[j]) {
            continue
          }
          let tmpObj = dataArr[j]
          let tmpEndX = tmpObj.leaflet_params.endPoint[0]
          let tmpEndY = tmpObj.leaflet_params.endPoint[1]
          if (distance(dataArr[i], dataArr[j]) < config.game.val.leaflet.showLineup.togetherDistance) {
            togetherObj.count += 1
            togetherObj.endX = (togetherObj.endX + tmpEndX) / 2
            togetherObj.endY = (togetherObj.endY + tmpEndY) / 2
            togetherObj.list.push(dataArr[j])
            dataArr[j] = null
          }
        }
        togetherList.push(togetherObj)
      }


      for (let i = 0; i < togetherList.length; i++) {
        let togetherObj = togetherList[i]
        //技能图片
        const endX = togetherObj.endX
        const endY = togetherObj.endY
        let imgSize = config.game[_this.currentPage].leaflet.showLineup.abilityImgSize
        let agent = togetherObj.agent
        let ability = togetherObj.ability
        let pngBounds = [[endX - imgSize / 2, endY - imgSize / 2], [endX + imgSize / 2, endY + imgSize / 2]]
        let png
        if (_this.currentPage === 'val') { //无畏契约的技能图片
          png = L.imageOverlay(config.game.val.agents[agent].ability[ability].imgSrc, pngBounds, {
            zIndex: 401,
            interactive: true,
            lineupList: togetherObj.list,
            togetherObj: togetherObj
          })
        } else if (_this.currentPage === 'cs2') { // CS2技能图片（烟火雷闪）
          png = L.imageOverlay(config.game.cs2.ability[ability].imgSrc, pngBounds, {
            zIndex: 401,
            interactive: true,
            lineupList: togetherObj.list,
            togetherObj: togetherObj
          })
        } else {
          png = L.imageOverlay(config.game.df.ability.imgSrc, pngBounds, {
            zIndex: 401,
            interactive: true,
            lineupList: togetherObj.list,
            togetherObj: togetherObj
          })
        }
        png.on('tap click', this.endCircleClick)
        endCircleLayerGroupArr.push(png)
        // 技能圆形底色
        if (_this.currentPage === 'val' || _this.currentPage === 'cs2') {
          let endCircle = L.circle([endX, endY], {
            radius: config.game[_this.currentPage].leaflet.showLineup.endCircle.radius,
            fillColor: config.game[_this.currentPage].leaflet.showLineup.endCircle.fillColor,
            fillOpacity: config.game[_this.currentPage].leaflet.showLineup.endCircle.fillOpacity,
            weight: config.game[_this.currentPage].leaflet.showLineup.endCircle.weight,
            lineupList: togetherObj.list,
            togetherObj: togetherObj
          })
          endCircle.on('tap click', this.endCircleClick)
          endCircleLayerGroupArr.push(endCircle)
        }

        // 直接显示的折线 viper烟墙 零的拌线, 这里有个问题，如果两个落点相同怎么处理, 目前直接显示第一个
        let firstLineupObj = togetherObj.list[0]
        if (firstLineupObj.leaflet_params.polylineWithEndPointList) {
          let tmpList = [firstLineupObj.leaflet_params.endPoint].concat(firstLineupObj.leaflet_params.polylineWithEndPointList)
          let polylineWithEndPoint = L.polyline(tmpList, {
            color: config.game.val.leaflet.showLineup.polylineWithEndPoint.color,
            weight: config.game.val.leaflet.showLineup.polylineWithEndPoint.weight
          })
          endCircleLayerGroupArr.push(polylineWithEndPoint)
        }
        // 额外的折线组，viper烟墙通过传送门时的情况
        if (firstLineupObj.leaflet_params.extraPolylineList) {
          let extraPolylineList = firstLineupObj.leaflet_params.extraPolylineList
          for (let i = 0; i < extraPolylineList.length; i++) {
            let polyline = L.polyline(extraPolylineList[i], {
              color: config.game.val.leaflet.showLineup.polylineWithEndPoint.color,
              weight: config.game.val.leaflet.showLineup.polylineWithEndPoint.weight
            })
            endCircleLayerGroupArr.push(polyline)
          }
        }

      }
      endCircleLayerGroup = L.layerGroup(endCircleLayerGroupArr)
      endCircleLayerGroup.addTo(map)


      // 鼠标移入技能图片事件
      function endCircleMouseOver(e) {
        // alert('移入')
        let arr = []
        // 在技能图片出显示一个圈
        let endX = e.sourceTarget.options.togetherObj.endX
        let endY = e.sourceTarget.options.togetherObj.endY
        let circle = L.circle([endX, endY], {
          radius: config.game[_this.currentPage].leaflet.showLineup.endCircleMouseOver.radius,
          color: config.game[_this.currentPage].leaflet.showLineup.endCircleMouseOver.color,
          weight: config.game[_this.currentPage].leaflet.showLineup.endCircleMouseOver.weight,
        })
        arr.push(circle)

        let lineupList = e.sourceTarget.options.lineupList
        // 单个lineup，不是多个站位聚合的，显示名称
        // if (lineupList.length === 1) {
        //   let currentUrl = lineupList[0].start_image
        //   previewText.textContent = lineupList[0].lineup_title
        //   showPreview(currentUrl, lineupList[0].leaflet_params.cutVideo);
        // }
        for (let i = 0; i < lineupList.length; i++) {
          let lineupObj = lineupList[i]
          //显示人物站点
          if (lineupObj.leaflet_params.startPoint) {
            let startX = lineupObj.leaflet_params.startPoint[0]
            let startY = lineupObj.leaflet_params.startPoint[1]
            //显示起始点的一条直线，
            // eslint-disable-next-line no-empty
            if (lineupObj.ability === 2 && lineupObj.agent_name === 'neon') {
              //霓虹的震不显示
            } else {
              let startEndLine = L.polyline([[startX, startY], [endX, endY]], {
                color: config.game.val.leaflet.showLineup.startEndLine.color,
                weight: config.game.val.leaflet.showLineup.startEndLine.weight,
              });
              arr.push(startEndLine)
            }

            // 无畏契约显示人物图片和背景色
            if (_this.currentPage === 'val' || _this.currentPage === 'df') {
              let imgSize = config.game[_this.currentPage].leaflet.showLineup.agentImgSize
              let agent = lineupObj.agent_name
              let pngBounds = [[startX - imgSize / 2, startY - imgSize / 2], [startX + imgSize / 2, startY + imgSize / 2]]
              let agentPng = L.imageOverlay(config.game[_this.currentPage].agents[agent].imgSrc, pngBounds, {
                zIndex: 401,
                interactive: true,
              })
              arr.push(agentPng)
              // 人物背景
              if (_this.currentPage === 'val') {
                let agentCircle = L.circle([startX, startY], {
                  radius: config.game.val.leaflet.showLineup.agentCircle.radius,
                  weight: config.game.val.leaflet.showLineup.agentCircle.weight,
                  fillOpacity: config.game.val.leaflet.showLineup.agentCircle.fillOpacity,
                  fillColor: config.game.val.agents[agent].color
                })
                arr.push(agentCircle)
              }
            } else { // CS2
              if (lineupObj.start_image === '') {
                //没有站位图片，常规位置，绘制圆圈站点
                let agentCircle = L.circle([startX, startY], {
                  radius: config.game.cs2.leaflet.showLineup.agentCircle.radius,
                  weight: config.game.cs2.leaflet.showLineup.agentCircle.weight,
                  fillOpacity: config.game.cs2.leaflet.showLineup.agentCircle.fillOpacity,
                  fillColor: config.game.cs2.leaflet.showLineup.agentCircle.fillColor,
                  color: config.game.cs2.leaflet.showLineup.agentCircle.color,
                  pane: 'labels'
                })
                arr.push(agentCircle)
              } else {
                // 有站位图片，一般是出生位快烟，绘制绿色正方形站点
                let sideLength = 40
                var bounds = [[startX - sideLength / 2, startY - sideLength / 2], [startX + sideLength / 2, startY + sideLength / 2]]
                let rectangle = L.rectangle(bounds, {
                  color: config.game.cs2.leaflet.showLineup.agentRectangle.color,
                  weight: config.game.cs2.leaflet.showLineup.agentRectangle.weight,
                  pane: 'labels'
                })
                arr.push(rectangle)
              }
            }
          }
        }
        //mouseover组显示
        mouseOverLayerGroup = L.layerGroup(arr)
        mouseOverLayerGroup.addTo(map)
      }

      // 鼠标移出技能图片事件
      function endCircleMouseOut() {
        if (mouseOverLayerGroup) {
          mouseOverLayerGroup.remove()
        }
        // 隐藏图片悬浮DIV
        hidePreview();
      }

      // 鼠标在圆圈上移动时显示名称
      function endCircleMouseMove(e) {
        positionPreview(e.originalEvent.pageX, e.originalEvent.pageY);
      }

      function agentCircleMouseMove(e) {
        positionPreview(e.originalEvent.pageX, e.originalEvent.pageY);
      }

      const OFFSET_X = 14
      const OFFSET_Y = 14
      const preview = document.getElementById('image-preview');
      const previewImg = document.getElementById('image-preview-img');
      const previewText = document.getElementById('image-preview-text');
      const previewVideo = document.getElementById('preview-video');
      const previewVideoBox = document.getElementById('video-box');

      function showPreview(imgName, cutVideo) {
        previewImg.src = ''
        preview.classList.add('show');
        preview.setAttribute('aria-hidden', 'false');
        if (imgName) {
          previewImg.src = 'https://img.lkval.com/static/start-image/' + imgName;
          previewImg.style.display = "block";
        } else {
          previewImg.style.display = "none";
        }
        if (cutVideo) {
          previewVideo.src = 'https://img.lkval.com/userupload/' + cutVideo;
          previewVideoBox.style.display = "block"
        } else {
          previewVideoBox.style.display = "None"
        }
      }

      function hidePreview() {
        preview.classList.remove('show');
        preview.setAttribute('aria-hidden', 'true');
        // 可选：延迟清空 src 避免频繁重新加载（按需）
        // previewImg.src = '';
      }

      function positionPreview(clientX, clientY) {
        // 基本位置在鼠标偏移处
        let left = clientX + OFFSET_X;
        let top = clientY + OFFSET_Y;

        // 边界检测：若靠近右/下边缘，则把预览移到左/上侧
        const padding = 8;
        const rect = preview.getBoundingClientRect();
        const vw = document.documentElement.clientWidth;
        const vh = document.documentElement.clientHeight;

        // 如果超出右边界
        if (left + rect.width + padding > vw) {
          left = clientX - rect.width - OFFSET_X;
        }
        // 如果超出下边界
        if (top + rect.height + padding > vh) {
          top = clientY - rect.height - OFFSET_Y;
        }

        // 最终应用
        preview.style.left = left + 'px';
        preview.style.top = top + 'px';
      }
    },

    cancelRequest() {
      if (typeof this.source === 'function') {
        this.source('终止请求')
      }
    },
    getLineupDetail(blogId) {
      axios({
        method: 'get',
        url: '/api/blogs/get_lineup_detail',
        params: {
          blog_id: blogId
        }
      }).then(r => {
        if (r.data.code !== 0) {
          this.$message.error(r.data.msg);
        } else {
          this.showDetailPage = true;
          this.detail = {}
          this.detailTitle = ''
          this.imageList = []
          this.videoSrc = ''
          this.linkWithSecond = ''
          this.detail = r.data.detail
          this.detailTitle = this.detail.title
          // 处理视频
          if (this.detail.bili_link) {
            const [videoSrc, linkWithSecond] = biliLinkToIframe(this.detail.bili_link, this.detail.bili_start_minute, this.detail.bili_start_second, this.detail.bili_iframe)
            this.videoSrc = videoSrc
            this.linkWithSecond = linkWithSecond
          }
          // 处理图片
          for (let i = 0; i < this.detail.images.length; i++) {
            this.imageList.push(imgNameToUrl(this.detail.images[i]))
          }
          this.$nextTick(() => {
            if (this.imageViewer) {
              this.imageViewer.destroy()
            }
            this.imageViewer = new Viewer(document.getElementById('images'))
          });
        }
      })
    },
    showAgentOptions() {
      this.agentOptionsVisible = true
    },
    showAbilityOptions() {
      this.abilityOptionsVisible = !this.abilityOptionsVisible
    },
    showCS2AbilityOptions() {
      this.cs2AbilityOptionsVisible = !this.cs2AbilityOptionsVisible
    },
    clickCS2SideOption() {
      this.userSelect.cs2.side = (this.userSelect.cs2.side + 1) % 3
      localStorage.setItem('userSelect', JSON.stringify(this.userSelect))
      this.selectChange()
    },
    clickAgentOption(name) {
      this.userSelect.val.agent = name
      this.agentOptionsVisible = false
      localStorage.setItem('userSelect', JSON.stringify(this.userSelect))
      this.selectChange()
    },
    getLineupCount() { // 获取每张地图 每个英雄的lineup个数
      axios({
        method: 'get',
        url: '/api/blogs/get_lineup_count',
      }).then(r => {
        if (r.data.code === 0) {
          this.agentToMap = r.data.agent_to_map
          this.mapToAgent = r.data.map_to_agent
          this.cs2MapToAbility = r.data.cs2_map_to_ability
          for (let i in this.agentToMap) {
            for (let j in this.agentToMap[i]) {
              let count = 0
              for (let k in this.agentToMap[i][j]) {
                count += this.agentToMap[i][j][k]
              }
              this.agentToMap[i][j]['count'] = count
            }
          }
          for (let i in this.mapToAgent) {
            for (let j in this.mapToAgent[i]) {
              let count = 0
              for (let k in this.mapToAgent[i][j]) {
                count += this.mapToAgent[i][j][k]
              }
              this.mapToAgent[i][j]['count'] = count
            }
          }
          for (let i in this.cs2MapToAbility) {
            let count = 0
            for (let j in this.cs2MapToAbility[i]) {
              count += this.cs2MapToAbility[i][j]
            }
            this.cs2MapToAbility[i]['count'] = count
          }
        }
      })
    },
    showMapOptions() {
      this.mapOptionsVisible = true
    },
    clickMapOption(name) {
      this.userSelect.val.map = name
      localStorage.setItem('userSelect', JSON.stringify(this.userSelect))
      this.mapOptionsVisible = false
      this.initMap()
      this.selectChange()
    },
    clickAbilityOption(name) { // 无畏契约点击技能
      this.userSelect.val.ability = name
      localStorage.setItem('userSelect', JSON.stringify(this.userSelect))
      this.abilityOptionsVisible = false
      this.selectChange()
    },
    showCS2MapOptions() {
      this.mapCS2OptionsVisible = true
    },
    clickCS2MapOption(name) {
      this.userSelect.cs2.map = name
      localStorage.setItem('userSelect', JSON.stringify(this.userSelect))
      this.mapCS2OptionsVisible = false
      this.initMap()
      this.selectChange()
    },
    clickDFMapOption(name) {
      this.userSelect.df.map = name
      localStorage.setItem('userSelect', JSON.stringify(this.userSelect))
      this.mapDFOptionsVisible = false
      this.initMap()
      this.selectChange()
    },
    clickCS2AbilityOption(name) {
      this.userSelect.cs2.ability = name
      localStorage.setItem('userSelect', JSON.stringify(this.userSelect))
      this.cs2AbilityOptionsVisible = false
      this.selectChange()
    },
    showDFMapOptions() {
      this.mapDFOptionsVisible = true
    },
    showDFAgentOptions() {
      this.agentDFOptionsVisible = true
    },
    clickDFAgentOption(name) {
      this.userSelect.df.agent = name
      this.agentDFOptionsVisible = false
      localStorage.setItem('userSelect', JSON.stringify(this.userSelect))
      this.selectChange()
    },
    getBlogListDetail(blogIdList, lineupTitle) {
      axios({
        method: 'get',
        url: "/api/blogs/get_blog_list_detail",
        params: {
          blog_id_list: blogIdList,
        }
      }).then(r => {
        if (r.data.code === 0) {
          this.vd_videoCardTitle = lineupTitle
          this.vd_videoCardList = r.data.list
          this.vd_videoDialogVisible = true
        }
      })
    },
    onLoadStart() {
      this.statusMsg = '资源开始加载 (206 是正常的)';
      console.log('Event: loadstart');
    },
    onLoadedData() {
      this.statusMsg = '数据已加载，准备播放';
      console.log('Event: loadeddata - 视频首帧已就绪');
    },
    onPlay() {
      this.statusMsg = '播放中';
      console.log('Event: play');
    },
    onError(e) {
      this.errorMsg = '视频加载错误';
      console.error('Video Error Event:', e);
      console.error('Error Code:', this.$refs.testVideo.error.code);
      console.error('Error Message:', this.$refs.testVideo.error.message);

      // 常见错误码解释
      // 1: MEDIA_ERR_ABORTED
      // 2: MEDIA_ERR_NETWORK (网络中断，可能是 CORS 或 链接失效)
      // 3: MEDIA_ERR_DECODE (格式不支持，如 H.265)
      // 4: MEDIA_ERR_SRC_NOT_SUPPORTED (URL 错误或格式完全不支持)
    },
    handleDialogOpen() {
      // 延迟执行，确保DOM已渲染
      setTimeout(() => {
        const videoElements = this.$refs.vdVideoRefs;
        if (videoElements) {
          // 处理单个/多个视频的情况
          const videos = Array.isArray(videoElements) ? videoElements : [videoElements];
          videos.forEach(video => {
            // 移动端强制触发播放
            try {
              video.play().catch(err => {
                console.log("视频播放触发失败，需用户交互:", err);
                // 记录失败但不报错，等待用户点击后再播放
              });
            } catch (e) {
              console.error("播放视频异常:", e);
            }
          });
        }
      }, 300);
    },
    handleVideoError(item) {
      console.error(`视频加载失败: ${item.vd_videoSrc}`);
      this.$set(item, 'loadError', true);
    },
    handleVideoCanPlay(e) {
      e.target.muted = true;
    },


  },
};
</script>

<style>
/* Reset default styles */
html, body {
  margin: 0;
  padding: 0;
  height: 100%;
  width: 100%;
  overflow: hidden; /* Prevent scroll on mobile */
}

#app-container {
  display: flex;
  flex-direction: column;
  height: 100dvh;
  /*width: 100vw;*/
  /*height: 100%; !* Changed from 100vh to 100% to respect browser toolbars *!*/
  width: 100%;
  position: relative;
}

#map-container {
  flex: 1; /* Takes up all available space */
  width: 100%;
  z-index: 1;
}

/* Detail Page Overlay Styles */
.detail-page-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3); /* Dimmed background for the top area */
  z-index: 3000; /* High z-index to cover everything */
  display: flex;
  flex-direction: column;
  justify-content: flex-end; /* Align content to bottom */
}

.detail-page-content {
  background-color: white;
  width: 100%;
  height: 85%; /* Occupy most of the screen */
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  box-shadow: 0 -5px 20px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  animation: slide-up 0.3s ease-out;
}

.detail-header {
  padding: 15px 20px;
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.detail-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: bold;
}

.close-btn {
  background: none;
  border: none;
  font-size: 24px;
  color: #999;
  cursor: pointer;
  padding: 0 5px;
}

.detail-body {
  flex: 1;
  overflow-y: auto; /* Allow scrolling within the content */
  padding: 20px;
}

.video-container {
  width: 100%;
  position: relative;
  padding-bottom: 56.25%; /* 16:9 Aspect Ratio */
  background-color: #000;
  margin-bottom: 20px;
  border-radius: 8px;
  overflow: hidden;
}

.video-container iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.image-gallery {
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-bottom: 20px;
}

.detail-image {
  width: 100%;
  border-radius: 8px;
  object-fit: cover;
}

.detail-text {
  font-size: 14px;
  color: #333;
  line-height: 1.6;
}

/* Transitions */
.slide-up-enter-active, .slide-up-leave-active {
  transition: transform 0.3s ease;
}

.slide-up-enter, .slide-up-leave-to {
  transform: translateY(100%);
}

.bottom-nav {
  height: 60px; /* Fixed height for bottom nav */
  background-color: #ffffff;
  border-top: 1px solid #e0e0e0;
  display: flex;
  justify-content: space-around;
  align-items: center;
  box-shadow: 0 -2px 5px rgba(0, 0, 0, 0.1);
  z-index: 2; /* Ensure it's above map controls if needed */

  /* Adapt to safe area on mobile devices (e.g. iPhone X home indicator) */
  padding-bottom: env(safe-area-inset-bottom);
  /* Adjust height to include safe area padding */
  box-sizing: content-box;
}

.nav-item-wrapper {
  flex: 1;
  display: flex;
  justify-content: center;
  position: relative; /* For absolute positioning of popup menu */
  height: 100%;
  /* Add divider line */
  border-right: 1px solid #e0e0e0;
}

.nav-item-wrapper:last-child {
  border-right: none;
}

.nav-btn {
  background: none;
  border: none;
  display: flex;
  flex-direction: row; /* Changed from column to row */
  align-items: center;
  justify-content: center;
  color: #666;
  font-size: 14px;
  padding: 0 10px;
  cursor: pointer;
  width: 100%;
  height: 100%;
}

.nav-btn:active, .nav-btn:focus {
  background-color: #f5f5f5;
  outline: none;
}

.nav-btn .icon {
  font-size: 20px;
  margin-right: 5px; /* Spacing between icon and text */
  /* Remove margin-bottom since we are now row-flex */
  margin-bottom: 0;
}

.nav-btn .label {
  font-size: 14px;
  white-space: nowrap;
}

/* Popup Menu Styles */
.popup-menu {
  position: absolute;
  bottom: 100%; /* Position above the button */
  left: 50%;
  transform: translateX(-50%);
  background-color: white;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  padding: 5px 0;
  z-index: 1000;
  margin-bottom: 10px; /* Spacing from the button */
}

/* Arrow for the popup menu */
.popup-menu::after {
  content: '';
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: white transparent transparent transparent;
}

.menu-item {
  padding: 10px 15px;
  cursor: pointer;
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #333;
}

.menu-item:hover {
  background-color: #f5f5f5;
}

.menu-icon {
  margin-right: 10px;
  font-size: 18px;
}

/* Ensure last button (image only) is centered properly */
.nav-btn .icon:only-child {
  margin-right: 0;
}

.game-icon {
  max-width: 80%; /* 图片最大宽度不超过容器 */
  max-height: 80%; /* 图片最大高度不超过容器 */
  display: block; /* 消除图片默认的行内空白（可选） */
  margin: 0 auto; /* 图片在容器中水平居中（可选） */
}

.map-icon {
  max-width: 80%; /* 图片最大宽度不超过容器 */
  max-height: 80%; /* 图片最大高度不超过容器 */
  display: block; /* 消除图片默认的行内空白（可选） */
  margin: 0 auto; /* 图片在容器中水平居中（可选） */
}

.agent-icon {
  max-width: 60%; /* 图片最大宽度不超过容器 */
  max-height: 60%; /* 图片最大高度不超过容器 */
  display: block; /* 消除图片默认的行内空白（可选） */
  margin: 0 auto; /* 图片在容器中水平居中（可选） */
}

.ability-icon {
  width: 35px;
  height: 35px;
}

.side-icon {
  width: 50px;
  height: 50px;
}

.out-parent {
  display: flex;
  width: 100%;
}

.share-item {
  flex: 1;
  height: 100%;
  margin-left: 2%;
  margin-right: 2%;
  display: flex;
  justify-items: center;
  align-items: center;
  cursor: pointer;
}

.agent-options {
  display: flex;
  flex-flow: wrap;
  /*justify-content: space-evenly;*/
  align-items: center;
}

.agent-options .agent-item {
  margin: 5px;
  width: 70px;
  height: 70px;
  position: relative;
  border-radius: 5px;
  cursor: pointer;
  overflow: hidden;
}

.agent-badge-item {
  margin: 10px;
}

.agent-options .agent-item img {
  width: 100%;
  transition: transform 0.3s;
}

.agent-options .agent-item:hover > img {
  transform: scale(1.2);
}

.map-options {
  display: flex;
  flex-flow: wrap;
  justify-content: space-evenly;
  align-items: center;
  width: 100%;
}

.map-options .map-item {
  width: 150px;
  margin: 3px;
  position: relative;
  cursor: pointer;
  overflow: hidden;
  border-radius: 10px;
}

.map-options .map-item img {
  width: 100%;
  transition: transform 0.3s;
}

.map-options .map-item:hover > img {
  transform: scale(1.2);
}

.map-options .map-item .map-title {
  position: absolute;
  bottom: 10%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  color: white;
  font-weight: 600;
  text-shadow: -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000;
}

.el-dialog__body {
  padding: 0 !important; /* 上/下 20px，左/右 30px，可自定义 */
}

.ability-item {
  width: 50px;
  height: 50px;
  background: #0f1923;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  /*margin-left: 15px;*/
  /*cursor: pointer;*/
  /*margin-bottom: 14px;*/
}

/* Ensure viewer z-index is higher than anything else */
.viewer-container {
  z-index: 9999 !important;
}

/* 关键修复：覆盖浏览器对无controls视频的隐藏样式 */
/* 优先级拉满，确保覆盖默认样式 */
.vd-video-content {
  display: block !important;
  height: 100% !important;
  width: 100% !important;
}

/* 对话框适配：移动端宽度调整 */
.vd-video-dialog /deep/ .el-dialog {
  width: 95% !important;
  margin: 0 auto !important;
}

@media (min-width: 768px) {
  .vd-video-dialog /deep/ .el-dialog {
    width: 80% !important;
  }
}

.vd-video-dialog /deep/ .el-dialog__body {
  padding: 15px !important;
  overflow-y: auto;
  max-height: 70vh;
  -webkit-overflow-scrolling: touch;
}

/* 视频列表容器：适配移动端的Grid布局 */
.vd-video-list-container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 15px;
  padding: 0 5px;
  width: 100%;
  box-sizing: border-box;
}

/* 小屏手机强制单列 */
@media (max-width: 375px) {
  .vd-video-list-container {
    grid-template-columns: 1fr;
    gap: 10px;
  }
}

/* 单个视频项：确保宽高正常 */
.vd-video-item {
  cursor: pointer;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s ease;
  -webkit-tap-highlight-color: transparent;
  width: 100%;
  box-sizing: border-box;
}

/* 视频容器：16:9比例 + 黑色背景 */
.vd-video-wrapper {
  position: relative;
  width: 100%;
  padding-top: 56.25%;
  overflow: hidden;
  background-color: #000;
}

/* 视频核心样式：覆盖隐藏规则 + 隐藏控件 */
.vd-video-content {
  position: absolute;
  top: 0;
  left: 0;
  object-fit: cover;
  /* 核心：屏蔽视频默认交互，确保控件不显示 */
  pointer-events: none;
  /* 兜底：防止其他样式覆盖 */
  opacity: 1 !important;
  visibility: visible !important;
}

.vd-video-placeholder {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  background-color: #f5f5f5;
}

.vd-video-text {
  padding: 12px 16px;
  font-size: 14px;
  color: #333;
  background-color: #f9f9f9;
  word-break: break-all;
}

</style>
